<template>
  <v-app>
    <v-content>
      <v-container fluid fill-height>
        <v-layout row wrap align-start="" justify-center>
          <v-flex  xs12 sm12 m12>
            <v-layout row wrap justify-center>
              <v-flex xs12 sm12 m12>
                <v-layout justify-center>
                </v-layout>
              </v-flex>
              <v-flex xs12 sm12 m12>
                <v-layout justify-center>
                  <v-alert v-model="okmessage" type="error">
                    {{$t('payment-could-not-completed-try-again')}} 
                  </v-alert>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12 sm12 m12>

            <v-alert v-model="nomessage" type="error">
              {{message}}
            </v-alert>
          </v-flex>



          <v-flex v-if="sifreyenileme" xs2 sm2 md2>
            <v-form ref="formnewuserstatus" v-model="valid">
              <v-layout justify-start="" align-start="" row wrap>
                <v-flex xs12 sm12 md12>
                  <div class="text-xs-center" style="margin-bottom:15px;">
                    <img src="../../../assets/images/arkman.png" alt="Arkman">
                  </div>
                </v-flex>
                <v-flex sm12 md12>
                  <v-layout align-center justify-center="" row fill-height>
                    <div> <strong class="title primary--text"> {{ $t('Create-New-Password') }} </strong></div>
                  </v-layout>
                </v-flex>

                <v-flex sm12 md12>
                  <v-alert :type="alerttype" :value="true" v-model="errorAlert" transition="scale-transition">
                    <span>{{ errorMsg }}</span>
                  </v-alert>
                </v-flex>

                <v-flex sm12 md12>
                  <v-text-field prepend-icon="lock" box="" counter="8" :placeholder="$t('Password')" v-model="Kullanici.Sifre"
                    :label="$t('Password')" id="password1" :type="e3 ? 'password' : 'text'" :rules="[rules.required]"
                    :append-icon="e3 ? 'visibility' : 'visibility_off'" @click:append="() => (e3 = !e3)">
                    <template v-slot:progress>
                    </template>

                  </v-text-field>
                </v-flex>
                <v-flex sm12 md12>
                  <v-text-field prepend-icon="lock" box="" counter="8" :placeholder="$t('Password-Again')" v-model="Kullanici.SifreConfirm"
                    :label="$t('Password')" id="password2" :type="e4 ? 'password' : 'text'" :rules="[rules.required]"
                    :append-icon="e4 ? 'visibility' : 'visibility_off'" @click:append="() => (e4 = !e4)"></v-text-field>
                </v-flex>
                <v-flex>
                  <v-layout justify-end="" row wrap>
                    <v-btn color="info" v-if="!sifresifirlabekle" @click="sifrekaydet()">Onayla</v-btn>
                    <v-progress-circular v-if="sifresifirlabekle" indeterminate color="info"></v-progress-circular>

                  </v-layout>
                </v-flex>
              </v-layout>
            </v-form>
          </v-flex>

          <template>
            <v-card>
              <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'"
                :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
                {{ text1 }}
                <v-btn flat color="pink" @click.native="snackbar = false"> {{ $t('Close') }} </v-btn>
              </v-snackbar>
            </v-card>
          </template>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
  import auth from '../../../api/auth'
  import _ from 'underscore'
  import router from '../../../router'
  import axios from 'axios'

  import {
    Trans
  } from '@/plugins/Translation'

  export default {



     data() {
        return {

      okmessage: true,
      nomessage: false,
      message: null,
      sifreyenileme: false,
      sifresifirlabekle: false,
      alerttype: 'error',
      confirmbekle: false,


      locale: 'tr',
      locales: [{
          locale: 'tr',
          title: 'Türkçe',
          href: 'turkey'
        },
        {
          locale: 'en',
          title: 'English',
          href: 'english'
        },
        {
          locale: 'de',
          title: 'Deutsch',
          href: 'germany'
        },
      ],
      Emailyeni: null,
      drawer: true,
      drawerRight: true,
      right: null,
      left: null,

      faturainfo: [],
      newuserstatus: true,
      loginstatus: true,
      drawer: null,
      e1: 0,
      e2: true,
      e3: true,
      e4: true,
      text1: '',
      snackbar: false,
      y: 'top',
      x: 'right',
      mode: '',
      bekle: false,
      timeout: 6000,
      rules: {
        required: (value) => !!value || this.$t('Mandatory-Areas'),
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || this.$t('Wrong-e-mail')
        }
      },
      Kullanici: {
        Email: null,
        Sifre: '',
        SifreConfirm: '',
        Token: null
      },
      unvan: null,
      confirm: null,
      Credential: {
        email: '',
        password: ''
      },
      valid: true,
      errorMsg: '',
      errorAlert: false,
      yenierrorMsg: '',
      yenierrorAlert: false,
      AnaSirketler: [],
      Sirketler: [],
      AnaSirket: {},
      Sirket: {}
      }
    },
    props: {
      source: String
    },

    methods: {


      changeLanguage(e) {
        const lang = e
        const to = this.$router.resolve({
          params: {
            lang
          }
        })
        return Trans.changeLanguage(lang).then(() => {
          this.$router.push(to.location)
          this.locale = e
        })
      },
      getImgUrl(pet) {
        var images = require.context('../../../assets/images', false, /\.png$/)
        return images('./' + pet + ".png")
      },
      apiLogin,
      sysLogin,
      anaSirketIleri,
      newUser,
      geriDon,
      saveUser,
      epostagonder,
      sifrekaydet
    },
    beforeMount: beforeMount,
  }

  function sifrekaydet() {


    if (this.$refs.formnewuserstatus.validate()) {

      if (this.Kullanici.Sifre == this.Kullanici.SifreConfirm) {
        this.sifresifirlabekle = true;
        var params = {
          Email: this.Kullanici.Email,
          Token: this.Kullanici.Token,
          Sifre: this.Kullanici.Sifre,
          PasswordChange: true
        }
        this.$http.post(auth.API_URL + 'api/RegisterAuth/WebTokenConfirm', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {

          if (response.body.Status == true) {
            this.alerttype = 'success';
            this.errorMsg = this.$t('Your-password-been-changed-you-are-being-redirected-login-page');
            this.errorAlert = true;

            // this.okmessage = true;
            // this.nomessage = false;
            // this.message = this.$t('Your-password-been-changed-you-are-being-redirected-login-page');
            this.sifresifirlabekle = false;

            var url = '#/login'
            setTimeout(function () {
              window.open(url, '_self')
            }.bind(this), 6000)


          } else {


            this.errorMsg = response.body.ResponseMessage
            this.alerttype = 'error';
            this.errorAlert = true;
            this.sifresifirlabekle = false;

          }

        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable-' + this.$t('New-User')
            this.snackbar = true
            this.sifresifirlabekle = false;

          } else {
            this.text1 = 'Service Unavailable-' + this.$t('New-User')
            this.snackbar = true
            this.sifresifirlabekle = false;
          }
        })


      } else {

        this.errorMsg = this.$t('Passwords-do-not-match')
        this.errorAlert = true;
        this.alerttype = 'error';

      }

    } 
  }


  function beforeMount() {

    //mail onayı
    if (this.$route.query.isl == 'confirmmail') {

      this.confirmbekle = true

      var userparams = {
        Email: this.$route.query.email,
        Token: this.$route.query.token,
      }

      this.$http.post(auth.API_URL + 'api/RegisterAuth/WebTokenConfirm', userparams, {
        headers: {

        }
      }).then((response) => {

        if (response.body.Status == true) {
          this.confirmbekle = false

          this.okmessage = true;
          this.nomessage = false;
          this.message = this.$t('Your-activated-being-redirected-login')
          var url = '#/login'
          setTimeout(function () {
            window.open(url, '_self')
          }.bind(this), 6000)
        } else {
          this.nomessage = true;
          this.confirmbekle = false

          this.okmessage = false;
          this.message = this.$t('mail-been-approved-mail-reset-password')
        }

      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable-WebTokenConfirm'
          this.snackbar = true
          this.confirmbekle = false

        } else {
          this.text1 = 'Service Unavailable-WebTokenConfirm'
          this.snackbar = true
          this.confirmbekle = false

        }
      })


    }

    if (this.$route.query.isl == 'confirmsifre') {

      this.Kullanici.Email = this.$route.query.email
      this.Kullanici.Token = this.$route.query.token
      this.sifreyenileme = true;

    }

  }



  function epostagonder(kime, token) {

    var okMail = auth.URL_MAIL + 'isl=confirmmail&token=' + token



    let formData = new FormData();

    formData.append('Konu', 'E-Posta Onay Maili')
    formData.append('to', kime)
    formData.append('mailType', '0')
    var okMail = auth.URL_MAIL + 'isl=confirmmail&token=' + token + this.$t('approve-your-mail-from-url-address')
    formData.append('formattedMessage', okMail)

    axios.defaults.baseURL = auth.API_URL;
    // axios.responseType = 'arraybuffer';
    axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';
    axios.post(auth.API_URL + 'api/Helpers/SendEmail',
        formData, {
          headers: {

          }
        }
      ).then((response) => {

        if (response.data == true) {
          this.text1 = this.$t('Approval-mail-sent-registered-system-approving-your-mail')
          this.snackbar = true
        } else {
          this.text1 = this.$t('user-record-created-approval-been-sent-mail')
          this.snackbar = true
        }
      })
      .catch(function () {});



  }

  function saveUser() {
    if (this.$refs.formnewuserstatus.validate()) {
      if (this.YeniKullanici.Sifre == this.confirm) {

        this.Emailyeni = this.YeniKullanici.email
        var musteribilgi = {
          Ad: this.unvan
        }
        var musteribilgiler = [];
        musteribilgiler.push(musteribilgi)
        this.YeniKullanici.MusteriBilgi = musteribilgiler
        var params1 = this.YeniKullanici;

        this.$http.post(auth.API_URL + 'api/Register/Create', params1, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {

          if (response.body.Status == true) {

            this.epostagonder(this.Emailyeni, response.body.UserToken)

            // this.errorMsg = 'Kayıt işlemi gerçekleşti. Giriş yapınız..';
            //this.errorAlert = true;
            this.newuserstatus = false;
            this.loginstatus = true;

          } else {
             this.text1 = this.$t(response.body.ResponseMessage)
            this.snackbar = true;
          }

        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable-' + this.$t('New-User')
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-' + this.$t('New-User')
            this.snackbar = true
          }
        })


      } else {
        this.errorMsg = this.$t('Passwords-do-not-match')
        this.errorAlert = true;
      }

    } else {

    }
  }

  function geriDon() {
    this.newuserstatus = false;
    this.loginstatus = true;
  }

  function newUser() {
    this.newuserstatus = true;
    this.loginstatus = false;
  }

  function apiLogin() {
    this.bekle = true;
    var credential = {
      Email: this.Credential.email,
      Password: this.Credential.password
    }
    auth.login(this, credential, this.$route.query.redirect)

  }

  function sysLogin() {
    ('syslogine girdi')
    var earsiv = 0
    var efatura = 0
    var response = JSON.parse(window.localStorage.getItem('response'));
    var sirketler = JSON.parse(window.localStorage.getItem('sirketler'));
    window.localStorage.setItem('token', response.Token.token);

    var sirketparams = {
      SirketKodu: this.Sirket.id
    }
    this.$http.post(auth.API_URL + 'api/Parameters/CompanyGet', sirketparams, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {


      earsiv = response.body.OpsiyonBilgileri.EArsiv
      efatura = response.body.OpsiyonBilgileri.EFaturaKullaniyor

      var credentials = {
        AnaSirketKodu: this.AnaSirket.id,
        SirketKodu: this.Sirket.id,
        SirketAdi: this.Sirket.text,
        SirketUnvani: this.Sirket.unvan,
        Sirketler: sirketler,
        EArsiv: earsiv,
        EFatura: efatura,
        CoperSirketNo:0,
      }


      window.localStorage.setItem('credentials', JSON.stringify(credentials));



    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-Company Get'
        this.snackbar = true
        this.load1 = true
        this.progress = false

        var credentials = {
          AnaSirketKodu: this.AnaSirket.id,
          SirketKodu: this.Sirket.id,
          SirketAdi: this.Sirket.text,
          SirketUnvani: this.Sirket.unvan,
          Sirketler: sirketler,
          EArsiv: earsiv,
          EFatura: efatura,
          CoperSirketNo:0,
        }

        window.localStorage.setItem('credentials', JSON.stringify(credentials));
      } else {
        this.text1 = 'Service Unavailable-Company Get'
        this.snackbar = true
        this.load1 = true
        this.progress = false
        var credentials = {
          AnaSirketKodu: this.AnaSirket.id,
          SirketKodu: this.Sirket.id,
          SirketAdi: this.Sirket.text,
          SirketUnvani: this.Sirket.unvan,
          Sirketler: sirketler,
          EArsiv: earsiv,
          EFatura: efatura,
          CoperSirketNo:0,
        }
        window.localStorage.setItem('credentials', JSON.stringify(credentials));
      }
    })

    window.localStorage.removeItem('response')
    window.localStorage.removeItem('sirketler')

    router.push({
      path: '/'
    })
  }

  function anaSirketIleri() {
    var response = JSON.parse(window.localStorage.getItem('response'));

    var anaSirketBilgiler = _.findWhere(response.MusteriDbler, {
      MusteriKod: this.AnaSirket.id
    })

    if (anaSirketBilgiler.GenelSirketler.length === 0) {
      this.errorAlert = true;
      this.errorMsg = this.$t('Registered-corporations-are-not-found')
      this.e1 = 2;
    } else {
      this.errorAlert = false;
      this.e1 = 3;

      var sirketler = [];

      Object.keys(anaSirketBilgiler.GenelSirketler).forEach(key => {
        var sirket = {
          text: anaSirketBilgiler.GenelSirketler[key].SirketAdi,
          id: anaSirketBilgiler.GenelSirketler[key].SirketKodu,
          unvan: anaSirketBilgiler.GenelSirketler[key].SirketUnvani
        }
        sirketler.push(sirket)
      });
      window.localStorage.setItem('sirketler', JSON.stringify(sirketler));
      this.Sirketler = sirketler;
      this.Sirket = sirketler[0];

    }

  }
</script>